import * as React from 'react';
import api from '../../../services/api';
import {
  Button,
  Box,
  FormControl,
  Divider,
  Popover,
  Typography
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useStoreActions } from 'easy-peasy';
import { TextField,Checkbox, IntegerField} from '../../../components';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import yupnanable from '../../../services/yup-nanable.js';


const DadosBasicos = ({ ano, watchEmpresaId }) => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const [firstPopoverAnchor, setFirstPopoverAnchor] = React.useState(null);
  const [secondPopoverAnchor, setSecondPopoverAnchor] = React.useState(null);
  const [thirdPopoverAnchor, setThirdPopoverAnchor] = React.useState(null);
  const [fourthPopoverAnchor, setFourthPopoverAnchor] = React.useState(null);
  const [fifthPopoverAnchor, setFifthPopoverAnchor] = React.useState(null);
  const [sixthPopoverAnchor, setSixthPopoverAnchor] = React.useState(null);

  const handleFirstClick = (event) => {
    setFirstPopoverAnchor(event.currentTarget);
  };

  const handleSecondClick = (event) => {
    setSecondPopoverAnchor(event.currentTarget);
  };

  const handleThirdClick = (event) => {
    setThirdPopoverAnchor(event.currentTarget);
  };

  const handleFourthClick = (event) => {
    setFourthPopoverAnchor(event.currentTarget);
  };
  const handleFifthClick = (event) => {
    setFifthPopoverAnchor(event.currentTarget);
  };

  const handleSixthClick = (event) => {
    setSixthPopoverAnchor(event.currentTarget);
  };
  const handleCloseFirstClick = (event) => {
    setFirstPopoverAnchor(null);
  };

  const handleCloseSecondClick = (event) => {
    setSecondPopoverAnchor(null);
  };

  const handleCloseThirdClick = (event) => {
    setThirdPopoverAnchor(null);
  };

  const handleCloseFourthClick = (event) => {
    setFourthPopoverAnchor(null);
  };
  const handleCloseFifthClick = (event) => {
    setFifthPopoverAnchor(null);
  };

  const handleCloseSixthClick = (event) => {
    setSixthPopoverAnchor(null);
  };


  const schema = yup.object({
    captacaoAguaSuperficial:yup.boolean().nullable()
      .label('A minha empresa realiza captação de água superficial').default(false),
    captacaoTotalAguaSuperficial:yup.number().integer().positive().nullable().nanable()
      .label('Água superficial (m³)'),
    captacaoTotalAguaMar:yup.number().integer().nullable().nanable()
      .label('Água do mar (m³)'),
    captacaoTotalAguaSubterranea:yup.number().integer().nullable().nanable()
      .label('Água subterrânea (m³)'),
    captacaoTotalAguaTerceiros:yup.number().integer().nullable().nanable()
      .label('Água de terceiros (m³)'),
    devolucaoMeioAmbiente:yup.number().integer().nullable().nanable()
      .label('Devolução meio ambiente (m³)'),
    disponibilizacaoTerceiros:yup.number().integer().nullable().nanable()
      .label('Disponibilização terceiros (m³)'),
    observacao: yup.string().nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label('Observações'),
    captacaoTotalAguaChuva:yup.number().integer().nullable().nanable()
      .label('Água de chuva (m³)'),
    captacaoTotalAguaMinerio:yup.number().integer().nullable().nanable()
      .label('Água presente no minério (m³)'),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
  });

  const { handleSubmit, reset,
          watch, formState: { isDirty, isSubmitting }
        } = useFormRef;

  const watchCaptacao = watch('captacaoAguaSuperficial')

  const onSave = async (data) => {
    startLoading();
    let result
    try {
      if (data.id) {
        result = await api.http.put(`/10/agua/empresa/${watchEmpresaId}/${data.id}`, {
          ...data,
          ano
        });
      } else {
        result = await api.http.post(`/10/agua/empresa/${watchEmpresaId}`, {
          ...data,
          ano:ano
        })
      }
      reset(result.data)
      stopLoading({ severity: 'success' });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };

  const loadDadosBasicos = async (mount) => {
    startLoading();
    try {
      let getDadosGeais = (await api.http.get(`/10/agua/empresa/${watchEmpresaId}/${ano}`));
      if (mount.isMounted)
        reset(getDadosGeais.data);
      stopLoading();
    } catch (error) {
      if(error.response && error.response.status==404) {
        if(mount.isMounted) {
          reset({
            captacaoAguaSuperficial:null,
            captacaoTotalAguaSuperficial:'',
            captacaoTotalAguaMar:'',
            captacaoTotalAguaSubterranea:'',
            captacaoTotalAguaTerceiros:'',
            captacaoTotalAguaChuva: '',
            captacaoTotalAguaMinerio: '',
            devolucaoMeioAmbiente:'',
            disponibilizacaoTerceiros:'',
            observacao:'',
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    };
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadDadosBasicos(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [watchEmpresaId, ano]);

  return (
    (<div>
      <Divider>
        <h3>Água</h3>
      </Divider>
      <FormControl  >
        <Checkbox field="captacaoAguaSuperficial"
                  schema={schema} useFormRef={useFormRef} />
      </FormControl>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
        '& .MuiSvgIcon-root': { verticalAlign: 'middle',ml:2 }
      }}>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>Qual a captação total de <strong>água superficial</strong>?
            <HelpOutlineIcon
              onClick={handleFirstClick}
            />
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <IntegerField
              field="captacaoTotalAguaSuperficial"
              disabled={watchCaptacao == 1 ?false:true}
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
          <Popover
            open={Boolean(firstPopoverAnchor)}
            anchorEl={firstPopoverAnchor}
            onClose={handleCloseFirstClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>
              Captação de água superficial: Captação de águas que ocorrem na superfície terrestre,
              tais como: córregos, rios, lagos, estuários, pântanos.
            </Typography>
          </Popover>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography>Qual a captação total de <strong>água do mar</strong>?
            <HelpOutlineIcon
              onClick={handleSecondClick}
            />
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <IntegerField
              field="captacaoTotalAguaMar"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
          <Popover
            open={Boolean(secondPopoverAnchor)}
            anchorEl={secondPopoverAnchor}
            onClose={handleCloseSecondClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>
              Captação de água do mar: Captação de águas dos oceanos.
            </Typography>
          </Popover>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography>Qual a captação total de <strong>água subterrânea</strong>?
            <HelpOutlineIcon
              onClick={handleThirdClick}
            />
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <IntegerField
              field="captacaoTotalAguaSubterranea"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
          <Popover
            open={Boolean(thirdPopoverAnchor)}
            anchorEl={thirdPopoverAnchor}
            onClose={handleCloseThirdClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>
              Captação de água subterrânea: Captação de águas que ocorrem no subsolo e surgências superficiais (nascentes).
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>Qual a captação total de <strong>água de terceiros</strong>?
            <HelpOutlineIcon
              onClick={handleFourthClick}
            />
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth>
            <IntegerField
              field="captacaoTotalAguaTerceiros"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
          <Popover
            open={Boolean(fourthPopoverAnchor)}
            anchorEl={fourthPopoverAnchor}
            onClose={handleCloseFourthClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2}}>
              Captação de água de terceiros: Provenientes de concessionárias de abastecimento de água e/ou terceiros.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Qual a captação total de <strong>água de chuva</strong>?
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="captacaoTotalAguaChuva"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Qual a captação total de <strong>água presente no minério</strong>?
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="captacaoTotalAguaMinerio"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
        </Grid>
      </Grid>
      <Divider sx={{ my:3 }}>
      </Divider>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
        '& .MuiSvgIcon-root': { verticalAlign: 'middle', ml: 2 }
      }}>

        <Grid
          size={{
            md: 9
          }}>
          <Typography>Qual a <strong>devolução ao meio ambiente</strong>?
            <HelpOutlineIcon
              onClick={handleFifthClick}
            />
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>

          <FormControl fullWidth >
            <IntegerField
              field="devolucaoMeioAmbiente"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
          <Popover
            open={Boolean(fifthPopoverAnchor)}
            anchorEl={fifthPopoverAnchor}
            onClose={handleCloseFifthClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2}}>
              Devolução ao meio ambiente: Água nova desviada ao meio ambiente:
              Captações realizadas com fins de rebaixamento de nível de água, escoamentos
              de superfícies e água de chuva interceptadospor áreas que possibilitem
              armazenamento temporário e que sejam descartados diretamente sem que sejam
              usados. Infiltrações, evaporações e outras perdas que retornam ao meio ambiente,
              bem como água de chuva que não foi utilizada no processo que foi descartada
              e/ou ficou armazenada como delta do processo.
              <br></br>
              Observação Importante! Para cálculo da devolução ao meio ambiente, antes de
              imputar as informações, o empreendedor deve desconsiderar as contribuições
              de água de chuva, avaliando cada particularidade, para que não tenha balanço
              hídrico negativo.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>

          <Typography>Qual a <strong>disponibilização a terceiros</strong>?
            <HelpOutlineIcon
              onClick={handleSixthClick}
            />
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="disponibilizacaoTerceiros"
              schema={schema}
              useFormRef={useFormRef} />
          </FormControl>
          <Popover
            open={Boolean(sixthPopoverAnchor)}
            anchorEl={sixthPopoverAnchor}
            onClose={handleCloseSixthClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2}}>
              Disponibilização a terceiros: Água nova desviada a terceiros: Captações realizadas com fins de rebaixamento de nível de água,
              escoamentos de superfícies e água de chuva interceptados por áreas que possibilitem armazenamento temporário e que sejam
              descartados diretamente sem que sejam usados.
            </Typography>
          </Popover>
        </Grid>
      </Grid>
      <Divider sx={{ my:3 }}>
      </Divider>
      <FormControl fullWidth >
        <TextField
          field="observacao"
          type="text"
          fullWidth
          multiline rows={4}
          schema={schema} useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }} />
      </FormControl>
      <Box sx={{mt:3}}>
        <Button variant="outlined" sx={{ mr: 2 }}
                onClick={()=>{reset();}} disabled={!isDirty || isSubmitting}>
          CANCELAR
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{ m: 1 }}
          onClick={handleSubmit(onSave)}
          disabled={!isDirty || isSubmitting}
        >
          Salvar
        </Button>
      </Box>
    </div>)
  );
};

export default DadosBasicos;
